import React from 'react';

import { ActiveDropTarget } from '../containers/ActiveDropTarget';
import { SelectedTilesContainer } from '../containers/SelectedTilesContainer';
import { SelectedBoardTiles } from '../containers/SelectedBoardTiles';
import { BoardState } from '../containers/BoardState';
import { BoardPosition } from '../containers/BoardPosition';
import { useParams } from 'react-router-dom';
import { ReadOnly } from '../containers/ReadOnly';
import { MagnifierContainer } from '../containers/MagnifierContainer';
import { DndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
import { UserId } from '../containers/UserId';

const dndOptions = {
    enableMouseEvents: true,
};

export const GameProviders: React.FC = ({ children }) => {
    // `userId` only exists for the `Review` routue
    const { id: roomId, userId } = useParams();

    const { userId: currentUserId } = UserId.useContainer();

    return (
        <DndProvider backend={TouchBackend} options={dndOptions}>
            <MagnifierContainer.Provider>
                <ReadOnly.Provider initialState={!!userId}>
                    <BoardPosition.Provider>
                        <BoardState.Provider initialState={{ roomId, userId: currentUserId }}>
                            <SelectedBoardTiles.Provider>
                                <SelectedTilesContainer.Provider>
                                    <ActiveDropTarget.Provider>
                                        {children}
                                    </ActiveDropTarget.Provider>
                                </SelectedTilesContainer.Provider>
                            </SelectedBoardTiles.Provider>
                        </BoardState.Provider>
                    </BoardPosition.Provider>
                </ReadOnly.Provider>
            </MagnifierContainer.Provider>
        </DndProvider>
    );
};

